import { createSlice } from "@reduxjs/toolkit";
import { fetchBranchTransactionOutward } from "./branchTransactionOutwardThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    status: "p", // default to Pending
  },
};

const branchTransactionOutwardSlice = createSlice({
  name: "branchTransactionOutward",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchTransactionOutward.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchTransactionOutward.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchBranchTransactionOutward.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = branchTransactionOutwardSlice.actions;
export default branchTransactionOutwardSlice.reducer;
